import { FilterMatchMode } from "primereact/api";

export class Efectivo {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            pais: {
                value: null,
                export: false,
                table: false,
                header: 'PAÍS DONDE SE LOCALIZA EL EFECTIVO:',
                required: 'País es requerido',
            },
            tipo_cuenta: {
                value: null,
                export: false,
                table: true,
                header: 'Tipo de Cuenta:',
                required: 'Tipo de Cuenta es requerido',
                matchMode: FilterMatchMode.CONTAINS,
            },
            numero_cuenta: {
                value: '',
                export: false,
                table: true,
                header: 'Número de Cuenta:',
                required: 'Número de Cuenta es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            institucion: {
                value: '',
                export: false,
                table: false,
                header: 'INSTITUCIÓN:',
                required: 'Institución es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 200,
                min: 4,
            },
            saldo: {
                value: null,
                export: false,
                table: true,
                sort: false,
                filter: false,
                header: 'SALDO A LA FECHA DE\nLA DECLARACIÓN\nUSD:',
                required: 'Valor es requerido',
            },
        }
    }

    optionLabel = 'nombre';
}
